import { useState, createContext, useContext } from "react";
const useOrganizatonCntx = createContext();
const setOrganizatonCntx = createContext();
export function OrganizatonCntx({ children }) {
    const [stOrganizaton, setStOrganizaton] = useState(null);
    return (
        <useOrganizatonCntx.Provider value={stOrganizaton}>
            <setOrganizatonCntx.Provider value={setStOrganizaton}>
                {children}
            </setOrganizatonCntx.Provider>
        </useOrganizatonCntx.Provider>
    )
}
export function UseOrganizaton() {
    return useContext(useOrganizatonCntx);
}
export function SetOrganizaton() {
    return useContext(setOrganizatonCntx);
}